import {
  python,
  walletcs,
  polyana,
  discount,
  pages,
  spotifyClone,
  airlimomontreal,
  limogesflorist,
  rssapp
} from '../Assets/Projects'

export const _projects = [
  {
    id: 1,
    title: 'Python Projects Repository',
    image: python,
    link: 'https://github.com/KxllSwxtch/python-projects-portfolio'
  },

  {
    id: 4,
    title: 'Zapovednaya Polyana',
    image: polyana,
    link: 'https://zapovednaya-polyana.ru/'
  },
  {
    id: 5,
    title: 'GitHub Pages',
    image: pages,
    link: 'https://githubpages.netlify.app/'
  },

  {
    id: 6,
    title: 'Spotify Clone',
    image: spotifyClone,
    link: 'https://spotify-clone-a95e5.web.app'
  },
  {
    id: 2,
    title: 'WalletCS',
    image: walletcs,
    link: 'https://www.walletcs.com/'
  },
  {
    id: 3,
    title: 'Discount Audio Visual',
    image: discount,
    link: 'https://discountaudiovisual.ca/'
  },
  {
    id: 7,
    title: 'AirLimoMontreal',
    image: airlimomontreal,
    link: 'https://www.airlimomontreal.com/'
  },
  {
    id: 8,
    title: 'LimogesFlorist',
    image: limogesflorist,
    link: 'https://www.limogesflorist.com/'
  },
  {
    id: 9,
    title: 'RSS.APP',
    image: rssapp,
    link: 'https://www.rss.app/'
  }
]
